import React from "react";
import { Column } from "@ant-design/plots";
import dayjs from "dayjs";
import "dayjs/locale/bg";
import { useNavigate } from "react-router-dom";
import { capitalizeTitleCase } from ".././../../utils/utility";
import DashboardHeader from "./DashboardHeader";
import redirectIcon from "../../../assets/images/redirectIcon.png";

dayjs.locale("bg");
const TurnoverChart = ({ dataTurnOver }) => {
  const navigate = useNavigate();
  const data = [
    {
      day: capitalizeTitleCase(dayjs().subtract(7, "day").format("ddd")),
      date: dayjs().subtract(7, "day").format("DD/MM"),
      Оборот: parseFloat(dataTurnOver.seventhDay.toFixed(2)),
    },
    {
      day: capitalizeTitleCase(dayjs().subtract(6, "day").format("ddd")),
      date: dayjs().subtract(6, "day").format("DD/MM"),
      Оборот: parseFloat(dataTurnOver.sixthDay.toFixed(2)),
    },
    {
      day: capitalizeTitleCase(dayjs().subtract(5, "day").format("ddd")),
      date: dayjs().subtract(5, "day").format("DD/MM"),
      Оборот: parseFloat(dataTurnOver.fifthDay.toFixed(2)),
    },
    {
      day: capitalizeTitleCase(dayjs().subtract(4, "day").format("ddd")),
      date: dayjs().subtract(4, "day").format("DD/MM"),
      Оборот: parseFloat(dataTurnOver.fourthDay.toFixed(2)),
    },
    {
      day: capitalizeTitleCase(dayjs().subtract(3, "day").format("ddd")),
      date: dayjs().subtract(3, "day").format("DD/MM"),
      Оборот: parseFloat(dataTurnOver.thirdDay.toFixed(2)),
    },
    {
      day: capitalizeTitleCase(dayjs().subtract(2, "day").format("ddd")),
      date: dayjs().subtract(2, "day").format("DD/MM"),
      Оборот: parseFloat(dataTurnOver.secondDay.toFixed(2)),
    },
    {
      day: capitalizeTitleCase(dayjs().subtract(1, "day").format("ddd")),
      date: dayjs().subtract(1, "day").format("DD/MM"),
      Оборот: parseFloat(dataTurnOver.firstDay.toFixed(2)),
    },
    // {
    //   day: capitalizeTitleCase("Днес"),
    //   date: dayjs().format("DD/MM"),
    //   Оборот: parseFloat(dataTurnOver.currentDay.toFixed(2)),
    // },
  ];

  const config = {
    data,
    xField: "day",
    yField: "Оборот",

    label: {
      position: (percent) => {
        const totalSum = data.reduce((acc, cur) => acc + cur.Оборот, 0);
        const individualPercentage = (percent.Оборот / totalSum) * 100;
        return individualPercentage < 3 ? "top" : "middle";
      },
      rotate: window.innerWidth < 1250 && "-1.58",
      formatter: (text) => {
        return text.Оборот === 0 ? "" : text.Оборот.toFixed(2);
      },
      style: {
        textBaseline: "middle",
      },
    },
    yAxis: {
      label: null,
    },
  };

  if (window.innerWidth > 770) {
    config.xAxis = {
      label: {
        formatter: (text, item, index) => {
          return `${text}\n${data[index].date}`;
        },
      },
    };
  }

  return (
    <div className="turnover-chart-main-container">
      <div className="dashboard-titles-container">
        <DashboardHeader
          text={`${dataTurnOver.name} - Отчети за последните 8 дни`}
        />
        <img
          id="action-button"
          src={redirectIcon}
          onClick={() => navigate("/reports")}
          alt="background"
          width="20px"
          height="20px"
        />
      </div>

      <Column {...config} className="turnover-chart-secondary-container" />
    </div>
  );
};

export default TurnoverChart;
